import { TTreeGroupType } from '@/shared/Tree/tree.types.ts'
import { ClassAttributes, FunctionComponent, HTMLAttributes, memo } from 'react'
import ListValuesIcon from '@/assets/icons/icon-list-values.svg?react'
import FolderIcon from '@/assets/icons/icon-folder.svg?react'
import FolderOpenIcon from '@/assets/icons/folder-open.svg?react'
import ArrowDownIcon from '@/assets/icons/arrowDown.svg?react'
import css from '@/shared/Tree/tree.module.css'

interface IProps {
  open: boolean
  onToggle: (open: boolean) => void
  groupType: TTreeGroupType
  expandable: boolean
}

const TreeGroupNodeExpandControl = (props: IProps) => {
  let DefaultIcon: FunctionComponent<ClassAttributes<SVGSVGElement> & HTMLAttributes<SVGSVGElement>>
  switch (props.groupType) {
    case 'folder':
      DefaultIcon = props.open ? FolderOpenIcon : FolderIcon
      break
    case 'list-values':
      DefaultIcon = ListValuesIcon
  }

  return (
    <div
      className={css.toggleIconWrapper}
      data-expandable={props.expandable}
      onClick={(ev) => {
        ev.stopPropagation()
        props.onToggle(!props.open)
      }}
    >
      {props.groupType !== 'none' && <DefaultIcon data-expandable={props.expandable} className={css.defaultIcon} />}
      {props.expandable && (
        <ArrowDownIcon
          className={css.toggleIconArrowIcon}
          style={{
            transition: 'transform 0.3s',
            transform: props.open ? 'rotate(0deg)' : 'rotate(-90deg)',
          }}
        />
      )}
    </div>
  )
}

export default memo(TreeGroupNodeExpandControl)
